// FALL 2026 WELCOME WEEK — seasonal content block.
//
// HOW TO MAINTAIN THIS FILE
// • To hide Welcome Week everywhere (announcement bar, homepage section, and the
//   Events page group) after August 28, 2026, set `welcomeWeekVisible` to false.
//   Nothing else needs to change and the permanent weekly schedule in
//   data/recurring.ts is unaffected.
// • Every place an event appears reads from this one array, so updating a value
//   here updates the whole site.
// • Do not add events, food, or locations that BCM leadership has not confirmed.

/** Master switch for all Welcome Week content. */
export const welcomeWeekVisible: boolean = true

export type WelcomeWeekDay = {
  id: string
  day: string
  date: string
  title: string
  time: string
  /** Confirmed location. Leave undefined while it is still pending. */
  location?: string
  /** Shown in place of a location while it is pending. */
  locationPending?: string
  description: string
  /** Short food or refreshment callout. */
  callout?: string
}

export const welcomeWeek = {
  range: 'August 24–28',
  rangeFull: 'August 24–28, 2026',
  heading: 'Welcome Week at UCF BCM',
  intro:
    'New to UCF? Looking for community? Come hang out with BCM all week. You’re welcome to jump in for one event or join us every night!',
  eventsHeading: 'Welcome Week 2026',
  eventsIntro:
    'Join UCF BCM August 24–28 for a full week of community, food, worship, and activities.',
} as const

export const welcomeWeekDays: WelcomeWeekDay[] = [
  {
    id: 'welcome-week-monday',
    day: 'Monday',
    date: 'August 24',
    title: 'Ice Cream & Board Games',
    time: '7:00 PM',
    location: 'UCF Student Union • 2nd Floor',
    description: 'Start Welcome Week with ice cream, games, and a chance to meet people.',
  },
  {
    id: 'welcome-week-tuesday',
    day: 'Tuesday',
    date: 'August 25',
    title: 'BBQ & Sports Night',
    time: '7:00 PM',
    location: 'By the RWC Leisure Pool',
    description: 'Come hang out for BBQ, sports, and a relaxed night with BCM.',
  },
  {
    id: 'welcome-week-wednesday',
    day: 'Wednesday',
    date: 'August 26',
    title: 'Pizza & Trivia Night',
    time: '7:00 PM',
    // TODO: Replace Wednesday Pizza & Trivia Night location once BCM confirms
    // the classroom. Set `location` and delete `locationPending`; every place
    // this event appears updates from this one value.
    locationPending: 'Location coming soon',
    description: 'Grab some pizza, team up for trivia, and meet more of the BCM community.',
  },
  {
    id: 'welcome-week-thursday',
    day: 'Thursday',
    date: 'August 27',
    title: 'Worship Night',
    time: '7:30 PM',
    // Matches the First Worship Night entry in data/events.ts exactly.
    location: 'Cape Florida Ballroom, Room 316 • UCF Student Union, 3rd Floor',
    callout: 'Free Chick-fil-A',
    description: 'Join us for worship, community, and the first Thursday night of the semester.',
  },
  {
    id: 'welcome-week-friday',
    day: 'Friday',
    date: 'August 28',
    title: 'Volleyball Night',
    time: '7:00 PM',
    location: 'Lake Claire Recreational Area',
    callout: 'Water & Gatorade',
    description: 'Finish Welcome Week with volleyball and a fun night outside with BCM.',
  },
]
